{
    "MakeCallTitle": "Anrufen",
    "MakeCallTooltip": "Rufen Sie das entsprechende Gerät an.",
    "IttTitle": "Anfrageübertragung",
    "IttTooltip": "Führen Sie einen Rückfrageanruf an das entsprechende Gerät durch, um eine Gesprächsübergabe zu starten.",
    "CallDetailsTitle": "Anrufdetails...",
    "CallDetailsTooltip": "Detaillierte Anrufinformationen in einem neuen Fenster anzeigen.",
    "CompleteTransferTitle": "Vollständige Übertragung",
    "CompleteTransferTooltip": "Schließen Sie den zuvor gestarteten Weiterleitungsvorgang für Rückfrageanrufe ab, indem Sie den gehaltenen Anruf an das zuvor angerufene Ziel weiterleiten.",
    "PickupThisCallTitle": "Nehmen Sie diesen Anruf entgegen",
    "PickupThisCallTooltip": "Diesen Benachrichtigungsanruf sofort an Ihrer eigenen Nebenstelle entgegengenommen.",
    "StealThisCallTitle": "Stehlen Sie diesen Anruf",
    "StealThisCallTooltip": "Verschieben Sie den aktuell entgegengenommenen oder signalisierenden Anruf zu Ihrer Nebenstelle, wo er anschließend klingelt.",
    "SendToCallTitle": "Anruf senden an...",
    "SendToCallTooltip": "Verschieben Sie den aktuell entgegengenommenen oder signalisierenden Anruf zu einem bestimmten neuen Ziel, wo er anschließend klingelt.",
    "MonitorTitle": "Monitor",
    "MonitorTooltip": "Geräte- und Anrufüberwachungsoptionen.",
    "SilentMonitorTitle": "Stiller Monitor",
    "SilentMonitorTooltip": "Starten Sie eine stille Überwachungssitzung mit dem aktuell angenommenen Anruf am Gerät.",
    "ForcedIntrudeTitle": "Erzwungenes Eindringen",
    "ForcedIntrudeTooltip": "Aufschalten (Aufschalten) in den aktuell entgegengenommenen Anruf am entsprechenden Gerät, damit Sie aktiv an diesem Anruf teilnehmen können.",
    "RecordCallTitle": "Anruf aufzeichnen",
    "RecordCallTooltip": "Führen Sie eine Live-Anrufaufzeichnung für den aktuell beantworteten Anruf am Gerät durch.",
    "RegisterCallbackTitle": "Rückruf registrieren",
    "RegisterCallbackTooltip": "Zeigen Sie eine Nachricht auf dem entsprechenden Gerät an, die Sie daran erinnert, Ihre bestimmte Nebenstelle zurückzurufen.",
    "AgentSignInOutTitle": "Agenten-An-\/Abmeldung",
    "AgentSignInOutTooltip": "Bei Nebenstelle an-\/abmelden.",
    "SignInTitle": "Einloggen...",
    "SignInTitleAllGroups": "Anmelden (Alle Gruppen)",
    "SignInTooltip": "Melden Sie das entsprechende Gerät oder den entsprechenden Agenten an und machen Sie ihn „im Dienst“ und möglicherweise verfügbar, um ACD-Anrufe anzunehmen.",
    "SignOutTitle": "Austragen",
    "SignOutTitleAllGroups": "Abmelden (alle Gruppen)",
    "SignOutTooltip": "Melden Sie das entsprechende Gerät oder den entsprechenden Agenten ab, wodurch sie „außer Dienst“ und nicht mehr für die Annahme von ACD-Anrufen verfügbar sind.",
    "GroupsTitle": "Gruppen",
    "GroupsTooltip": "Wählen Sie aus, bei welchen ACD-Gruppen dieser Agent angemeldet ist.",
    "NoGroupsTooltip": "Für diesen Agenten wurden keine ACD-Gruppen gefunden.",
    "GroupsAllTitle": "[Alle]",
    "SetDndOnTitle": "DND einschalten",
    "SetDndOnTooltip": "Schalten Sie „Nicht stören“ auf dem Gerät ein, wodurch es nicht mehr für den Empfang von Anrufen verfügbar ist.",
    "SetDndOffTitle": "Schalten Sie DND aus",
    "SetDndOffTooltip": "Deaktivieren Sie „Nicht stören“ auf dem Gerät, wodurch es für den Empfang eingehender Anrufe verfügbar ist.",
    "SetStatusTitle": "Status festlegen",
    "SetStatusTooltip": "Legen Sie den ACD-Status für diesen Agenten fest.",
    "AvailableTitle": "Verfügbar",
    "AvailableTooltip": "Versetzen Sie den Agenten in den Status „Verfügbar“, wodurch er für die Annahme von ACD-Anrufen verfügbar ist.",
    "DndTitle": "DND",
    "DndTooltip": "Versetzen Sie den Agenten in den DND-Status, wodurch er für die Annahme von ACD-Anrufen nicht verfügbar ist.",
    "WrapUpTitle": "Einpacken",
    "WrapUpTooltip": "Versetzen Sie den Agenten in den Nachbearbeitungsstatus, wodurch er für die Beantwortung von ACD-Anrufen nicht verfügbar ist.",
    "NotAvailableTitle": "Nicht verfügbar",
    "NotAvailableTooltip": "Setzen Sie den Agenten in den ACD-Status „Nicht verfügbar“ und geben Sie zusätzlich einen Ursachencode an, der verwendet werden kann, um zu identifizieren, warum der entsprechende Agent gerade nicht verfügbar ist, um ACD-Anrufe zu beantworten.",
    "NoReasonTitle": "[Kein Grund]",
    "NoReasonTooltip": "Setzen Sie den Agenten ohne Angabe von Gründen in den ACD-Status „Nicht verfügbar“.",
    "AdvancedTooltip": "Erweiterte Anrufsteuerungsaktionen.",
    "AnswerCallTitle": "Anruf beantworten",
    "AnswerCallTooltip": "Beantworten Sie den aktuell eingehenden Anruf.",
    "ClearCallTitle": "Anruf löschen",
    "ClearCallTooltip": "Beenden Sie den entsprechenden Anruf.",
    "AdminOnlyTitle": "Nur Administrator",
    "AdminOnlyTooltip": "Nur Administratoraktionen.",
    "DeletePhantomTitle": "Phantomruf löschen",
    "DeletePhantomTooltip": "Zwingen Sie die Anwendung dazu, den entsprechenden Anruf nicht mehr als aktiv zu modellieren, was sich negativ auf die Anrufstatistik auswirken kann.",
    "RowOptions_AdvancedTitle": "Fortschrittlich",
    "NAME": "RowOptions",
    "SetAccountCodeMenuOptionTitle": "Kontocode einstellen",
    "SetAccountCodeMenuOptionTooltip": "Kontocode für diesen Anruf einstellen.",
    "NoAccountCodeMenuOptionTitle": "[Kein Kontocode]",
    "NoAccountCodeMenuOptionTooltip": "Den Kontocode zurücksetzen",
    "AccountCodeMenuOptionTooltip": "Stellen Sie den Kontocode '{}' für den Anruf ein."
}